const require_serializerHelpers = require("../lib/serializerHelpers.cjs");
const require_serialize = require("../richtext/serialize.cjs");
const require_wrapMapSerializer = require("../richtext/wrapMapSerializer.cjs");
const require_composeSerializers = require("../richtext/composeSerializers.cjs");
//#region src/helpers/asHTML.ts
/**
* Creates a HTML rich text serializer with a given link resolver and provide sensible and safe
* defaults for every node type
*
* @internal
*/
const createHTMLRichTextSerializer = (linkResolver, serializer) => {
	const useSerializerOrDefault = (nodeSerializerOrShorthand, defaultWithShorthand) => {
		if (typeof nodeSerializerOrShorthand === "function") return ((payload) => {
			return nodeSerializerOrShorthand?.(payload) || defaultWithShorthand(payload);
		});
		return defaultWithShorthand;
	};
	return wrapMapSerializerWithStringChildren({
		heading1: useSerializerOrDefault(serializer?.heading1, require_serializerHelpers.serializeStandardTag("h1", serializer?.heading1)),
		heading2: useSerializerOrDefault(serializer?.heading2, require_serializerHelpers.serializeStandardTag("h2", serializer?.heading2)),
		heading3: useSerializerOrDefault(serializer?.heading3, require_serializerHelpers.serializeStandardTag("h3", serializer?.heading3)),
		heading4: useSerializerOrDefault(serializer?.heading4, require_serializerHelpers.serializeStandardTag("h4", serializer?.heading4)),
		heading5: useSerializerOrDefault(serializer?.heading5, require_serializerHelpers.serializeStandardTag("h5", serializer?.heading5)),
		heading6: useSerializerOrDefault(serializer?.heading6, require_serializerHelpers.serializeStandardTag("h6", serializer?.heading6)),
		paragraph: useSerializerOrDefault(serializer?.paragraph, require_serializerHelpers.serializeStandardTag("p", serializer?.paragraph)),
		preformatted: useSerializerOrDefault(serializer?.preformatted, require_serializerHelpers.serializePreFormatted(serializer?.preformatted)),
		strong: useSerializerOrDefault(serializer?.strong, require_serializerHelpers.serializeStandardTag("strong", serializer?.strong)),
		em: useSerializerOrDefault(serializer?.em, require_serializerHelpers.serializeStandardTag("em", serializer?.em)),
		listItem: useSerializerOrDefault(serializer?.listItem, require_serializerHelpers.serializeStandardTag("li", serializer?.listItem)),
		oListItem: useSerializerOrDefault(serializer?.oListItem, require_serializerHelpers.serializeStandardTag("li", serializer?.oListItem)),
		list: useSerializerOrDefault(serializer?.list, require_serializerHelpers.serializeStandardTag("ul", serializer?.list)),
		oList: useSerializerOrDefault(serializer?.oList, require_serializerHelpers.serializeStandardTag("ol", serializer?.oList)),
		image: useSerializerOrDefault(serializer?.image, require_serializerHelpers.serializeImage(linkResolver, serializer?.image)),
		embed: useSerializerOrDefault(serializer?.embed, require_serializerHelpers.serializeEmbed(serializer?.embed)),
		hyperlink: useSerializerOrDefault(serializer?.hyperlink, require_serializerHelpers.serializeHyperlink(linkResolver, serializer?.hyperlink)),
		label: useSerializerOrDefault(serializer?.label, require_serializerHelpers.serializeStandardTag("span", serializer?.label)),
		span: useSerializerOrDefault(serializer?.span, require_serializerHelpers.serializeSpan())
	});
};
/**
* Wraps a map serializer into a regular function serializer. The given map serializer should accept
* children as a string, not as an array of strings like `@prismicio/client/richtext`'s
* `wrapMapSerializer`.
*
* @param mapSerializer - Map serializer to wrap
* @returns A regular function serializer
*/
const wrapMapSerializerWithStringChildren = (mapSerializer) => {
	const modifiedMapSerializer = {};
	for (const tag in mapSerializer) {
		const tagSerializer = mapSerializer[tag];
		if (tagSerializer) modifiedMapSerializer[tag] = (payload) => {
			return tagSerializer({
				...payload,
				children: payload.children.join("")
			});
		};
	}
	return require_wrapMapSerializer.wrapMapSerializer(modifiedMapSerializer);
};
const asHTML = (richTextField, ...configObjectOrTuple) => {
	if (richTextField) {
		const [configObjectOrLinkResolver, maybeSerializer] = configObjectOrTuple;
		let config;
		if (typeof configObjectOrLinkResolver === "function" || configObjectOrLinkResolver == null) config = {
			linkResolver: configObjectOrLinkResolver,
			serializer: maybeSerializer
		};
		else config = { ...configObjectOrLinkResolver };
		let serializer;
		if (config.serializer) if (typeof config.serializer === "function") serializer = require_composeSerializers.composeSerializers((type, node, text, children, key) => config.serializer(type, node, text, children.join(""), key), createHTMLRichTextSerializer(config.linkResolver));
		else serializer = createHTMLRichTextSerializer(config.linkResolver, config.serializer);
		else serializer = createHTMLRichTextSerializer(config.linkResolver);
		return require_serialize.serialize(richTextField, serializer).join("");
	} else return null;
};
//#endregion
exports.asHTML = asHTML;

//# sourceMappingURL=asHTML.cjs.map